import { keyCode as KEY_CODES } from '@bingads-webui/keycode';

export const wrapKeyDownEvent = availablekeys => handler => ({ keyCode }, ...params) => {
  if (keyCode in availablekeys) {
    handler(...params);
  }
};

export const submitEvent = wrapKeyDownEvent({ [KEY_CODES.Enter]: null });
